import axios from 'axios';

import { SET_BUCKET_DOMAIN, SET_BUCKET_DOMAIN_TOKEN } from './mutationTypes';

// export const getUrlAndTokenOfImageUpload = async ({ commit }) => {
//   const response = await qiniuInfo();
//   commit(SET_BUCKET_DOMAIN, response.data.BucketDomain);
//   commit(SET_BUCKET_DOMAIN_TOKEN, response.data.token);
// };
export const getUrlDomain = async ({ commit }) => {
  const response = await getOss();
  // commit(SET_BUCKET_DOMAIN_TOKEN, response.data.BucketDomain);
};
